<ng-container *ngIf="!isCurrentUser && showChatButton">
  <ng-container *ngIf="isRounded; else normalButton">
    <button
      pButton
      type="button"
      icon="pi pi-comments"
      class="p-button-rounded p-button-outlined"
      (click)="onOpenConversation($event)"
    ></button>
  </ng-container>

  <ng-template #normalButton>
    <p-button
      icon="pi pi-comments"
      styleClass="p-button-outlined"
      label="{{ 'shared.privateConversationButton' | translate}}"
      (click)="onOpenConversation($event)"
    ></p-button>
  </ng-template>
</ng-container>
